import styled, {css} from 'styled-components';
import {BoxProps} from '@material-ui/core';
import {getDirectionStyles} from '../../utils/ThemeUtils';
import {makeStyles, Theme} from '@material-ui/core/styles';

export interface ContainerProps extends BoxProps {
    gridTemplateColumns?: string;
    gridTemplateColumnsSM?: string;
}

export const useContainerStyles = makeStyles<Theme, ContainerProps>(theme => ({
    root: props => ({
        display: 'grid',
        minHeight: 60,
        gridTemplateColumns: props.gridTemplateColumnsSM || 'repeat(2, 1fr)',
        gridGap: theme.spacing(1),
        margin: theme.spacing(-2, -2, 1, -2),

        [theme.breakpoints.up('fxs')]: {
            gridGap: theme.spacing(2),
            margin: theme.spacing(-1, -1, 1, -1)
        },

        [theme.breakpoints.up('fmd')]: {
            gridAutoRows: 74,
            gridTemplateColumns: props.gridTemplateColumns || 'repeat(4, 1fr)',
            gridGap: theme.spacing(3),

            margin: theme.spacing(0, 0, 1, 0)
        },

        [theme.breakpoints.up('xl')]: {
            gridAutoRows: 82
        }
    })
}));

export const ItemWrapper = styled.div`
    position: relative;
    min-width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 60px;
    border-radius: 4px;
    padding: ${p => p.theme.muiTheme.spacing(2, 0)};
    background-color: rgba(255, 255, 255, 0.04);

    & [class*='TrendWrapper'] {
        margin-bottom: ${p => p.theme.muiTheme.spacing(-1)}px;

        & svg {
            margin-bottom: -1px;
        }
    }

    & > span {
        display: inline-flex;
        align-items: center;
        text-align: center;
        line-height: 15px;
        margin: ${p => p.theme.muiTheme.spacing(0, 5)};

        & > div {
            // Tooltip
            position: absolute;
            top: 5px;
            ${p =>
                getDirectionStyles(p.theme.muiTheme.direction)(
                    css`
                        right: -5px;
                    `,
                    css`
                        left: -5px;
                    `
                )}

            margin-right: ${p => p.theme.muiTheme.spacing(2)}px;
        }
    }

    & > div {
        display: inline-flex;
        align-items: center;

        & > h4 {
            display: inline-flex;

            & > div {
                direction: ltr;
                margin: ${p => p.theme.muiTheme.spacing(0, 1)};
            }
        }

        & > *:nth-child(2) {
            direction: ltr;
            margin-left: ${p => p.theme.muiTheme.spacing(2)}px;
            margin-right: ${p => p.theme.muiTheme.spacing(2)}px;
        }
    }

    ${p => p.theme.muiTheme.breakpoints.up('fsm')} {
        & > span > div {
            position: initial;
        }
    }

    ${p => p.theme.muiTheme.breakpoints.up('fmd')} {
        padding: ${p => p.theme.muiTheme.spacing(3, 0)};
    }
`;
